module.exports = __webpack_public_path__ + "static/media/ios-nuclear.3e069dd3.svg";